import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://zuphopurmhhmbxukmffg.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp1cGhvcHVybWhobWJ4dWttZmZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NTk2NTA5ODEsImV4cCI6MTk3NTIyNjk4MX0.SiEmV83h4nc4NZcP_g2eEG-vLieUpJt89j_WY4dNGfY";
const supabase = createClient(supabaseUrl, supabaseKey, {});

export default supabase;
